module.exports = __webpack_public_path__ + "static/insolehp-44b35e1b923c8a6aa61a223f365f2de2.png";